import { z } from 'zod';
export const SearchSchema = z.object({
  /**
   * アプリ連携の結果
   * @note バックエンドからのリダイレクト時に付与
   */
  result: z.enum(['success', 'error']),
  /**
   * アプリ連携の結果が成功の場合に生成される連携ID
   * @note バックエンドからのリダイレクト時に付与
   */
  appIntegrationId: z.string().optional(),
  /**
   * アプリ連携の結果が成功の場合に生成される Software ID。
   * @note バックエンドからのリダイレクト時に `appIntegrationId` と同時に付与される
   *       (OAuth callback / install API のレスポンス)
   */
  softwareId: z.string().optional(),
  /**
   * エラーメッセージ。`result` が `error` の場合のみ付与
   * @note バックエンドからのリダイレクト時に付与
   */
  errorMessage: z.string().optional().transform(s => s?.replaceAll('+', ' '))
});
export type SearchSchema = z.infer<typeof SearchSchema>;